<template>
  <widget-template title="Revenue Sales Chart">
    <div slot="title">
      <div>
        <div class="headline">Revenue Sales Chart</div>
        <span class="grey--text">{{ myRevenueSalesChart.info }}</span>
      </div>
    </div>
    <div>
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div v-on="on">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-calendar-today</v-icon> {{ selectedScope.description }} </v-layout>
              <span>{{ selectedScope.info }}</span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-item v-for="(option, key) in scopes" :key="key" @click="doSelectScope(key)">
              <v-list-item-title>{{ option.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
      |
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <div v-on="on">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-view-grid</v-icon> {{ selectedAppId.description }} </v-layout>
              <span>
                {{ permittedAppIdsText }}
              </span>
            </v-tooltip>
          </div>
          <v-list>
            <v-list-item v-for="(appId, index) in appIds" :key="index" @click="doSelectAppId(appId.id)">
              <v-list-item-title>{{ appId.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
    </div>
    <div class="mt-4" style="position: relative">
      <v-layout>
        <v-flex lg12 md12 xs12>
          <v-card class="mt-4 mx-auto" max-width="520">
            <v-sheet class="v-sheet--offset mx-auto" color="cyan" elevation="6" max-width="calc(100% - 32px)">
              <chartist ratio="ct-major-tenth" type="Line" :data="srData" :options="srOptions"> </chartist>
            </v-sheet>
            <v-card-text class="pt-0">
              <div class="subheading font-weight-light grey--text">
                <v-icon color="green">mdi-arrow-up</v-icon><span style="color: green">25%</span> increase in today's sales
              </div>
              <v-divider class="my-2"></v-divider>
              <div slot="action">
                <div v-if="initState === 0">
                  <v-tooltip bottom>
                    <span v-on="on" class="grey--text">
                      <v-icon small color="orange">mdi-record</v-icon>
                      Loading...
                    </span>
                    <span>Loading</span>
                  </v-tooltip>
                </div>
                <div v-else-if="initState === 1">
                  <v-tooltip bottom>
                    <div v-on="on" @click="doReload" class="widgetAction grey--text">
                      <v-icon small>mdi-refresh</v-icon>
                      Updated {{ lastUpdated }} ago
                    </div>
                    <span>Click to update</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <span v-on="on" @click="doReload" class="widgetAction grey--text">
                      <v-icon small color="red">mdi-record</v-icon>
                      Error
                    </span>
                    <span>Click to retry</span>
                  </v-tooltip>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { longScopeMixin } from '../longScopeMixin'

export default {
  data() {
    return {
      widgetForm: {
        scope: 'days',
        appId: 'all'
      },
      srData: {},
      srOptions: {
        low: 0,
        showArea: true,
        axisY: {
          offset: 60,
          labelInterpolationFnc: function (value) {
            return '$' + value + 'm'
          }
        }
      }
    }
  },
  watch: {
    'myRevenueSalesChart.chartInfo': function (value) {
      this.compileData(value)
    }
  },
  computed: {
    myRevenueSalesChart() {
      return this.$store.state.widgets.myRevenueSalesChart
    },
    initState() {
      return this.myRevenueSalesChart.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.myRevenueSalesChart.lastUpdated, this.timeNow)
    },
    permittedAppIdsText() {
      return this.formatPermitAppIdsText(this.myRevenueSalesChart.appIds)
    }
  },
  methods: {
    ...mapActions(['initMyRevenueSalesChart']),
    doReload() {
      // Combine Form
      this.widgetForm.scope = this.scopeForm.scope
      this.widgetForm.appId = this.appIdForm.appId
      this.initMyRevenueSalesChart(this.widgetForm)
    },
    compileData(value) {
      // console.log(value[0].rData)
      this.srData = value[0].rData
    }
  },
  mounted() {
    if (this.initState !== 1) {
      // Default values
      this.doSelectScope('days', false)
      this.doSelectAppId('all')
    } else {
      // Doesnt want to do auto refresh here (save bandwidth, let user do it manually)
      if (this.myRevenueSalesChart.scope) {
        this.doSelectScope(this.myRevenueSalesChart.scope, false)
      }
      if (this.myRevenueSalesChart.appId) {
        this.doSelectAppId(this.myRevenueSalesChart.appId, false)
      }
      // compile data
      this.compileData(this.myRevenueSalesChart.chartInfo)
    }
  },
  mixins: [longScopeMixin()]
}
</script>

<style lang="scss">
@import 'chartist/dist/scss/chartist.scss';
.v-sheet {
  border-radius: 4px !important;
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.v-card--material-stats.v-card .v-offset .v-card {
  max-width: 85px;
  max-height: 85px;
  line-height: 85px;
  padding: 15px !important;
}
.ct-series-a .ct-line {
  /* Set the colour of this series line */
  stroke: #e5e5e5;
}
.ct-series-a .ct-point {
  /* Colour of your points */
  stroke: #e5e5e5;
}
.ct-series-a .ct-bar {
  /* Colour of your bars */
  stroke: #e5e5e5;
}
.ct-label {
  fill: #e5e5e5 !important;
  color: #e5e5e5 !important;
  font-size: 0.75rem;
  line-height: 1;
}
.ct-series-a .ct-slice-pie {
  fill: rgb(50, 165, 241);
  stroke: #e5e5e5;
  stroke-width: 2px;
}
</style>
